import { BaseRecord, useOne, useResourceParams } from '@refinedev/core';

const useCurrentResource = <TData extends BaseRecord>() => {
  const { id, resourceName, ...restResource } = useResourceParams();
  const { result, ...rest } = useOne<TData>({ id: id as string, resource: resourceName });

  return { ...restResource, id, resourceName, data: result || null, ...rest };
};

export default useCurrentResource;
